import ReferencesUserArchive from 'features/references/referencesUserArchive';
import { useTitle } from '../helpers';

/**
 * @page References user archive page
 */

const ReferencesUserArchivePage = () => {
  useTitle('Информация о справке в архиве');

  return (
    <div>
      <h3>Страница информации о справке в архиве</h3>
      <ReferencesUserArchive />
    </div>
  );
};

export default ReferencesUserArchivePage;
